import styled from 'styled-components';

import * as vr from 'core/styles/variables';

export const HelpText = styled.span`
	margin: 5px 0 10px;
	font-size: ${vr.formfieldHelpTextFontSize};
	display: block;
`;
